export default __webpack_public_path__ + "static/media/43_photo.f3185df8.jpg";